"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoticeGroupEnum = void 0;
var NoticeGroupEnum;
(function (NoticeGroupEnum) {
  /** Системные уведомления (всегда отправляются) */
  NoticeGroupEnum[NoticeGroupEnum["core"] = 0] = "core";
  /** Новое сообщение (в чате) */
  NoticeGroupEnum[NoticeGroupEnum["chat"] = 1] = "chat";
  /** Нравится / Не нравится */
  NoticeGroupEnum[NoticeGroupEnum["like"] = 2] = "like";
  /** Поделились */
  NoticeGroupEnum[NoticeGroupEnum["share"] = 3] = "share";
  /** Комментарии (к контенту) */
  NoticeGroupEnum[NoticeGroupEnum["comment"] = 4] = "comment";
  /** Упоминания */
  NoticeGroupEnum[NoticeGroupEnum["mention"] = 5] = "mention";
  /** Новый подписчик */
  NoticeGroupEnum[NoticeGroupEnum["subscriber"] = 6] = "subscriber";
  /** Приглашение в группу */
  NoticeGroupEnum[NoticeGroupEnum["group"] = 7] = "group";
  /** Дни рождения */
  NoticeGroupEnum[NoticeGroupEnum["birthday"] = 8] = "birthday";
  /** Ближайшее мероприятие */
  NoticeGroupEnum[NoticeGroupEnum["schedule"] = 9] = "schedule";
  /** Ожидание оплаты */
  NoticeGroupEnum[NoticeGroupEnum["payment"] = 10] = "payment";
  /** Рейтинг */
  NoticeGroupEnum[NoticeGroupEnum["rating"] = 11] = "rating";
  /** Отзывы */
  NoticeGroupEnum[NoticeGroupEnum["review"] = 12] = "review";
  /** Новый преподаватель по избранным дисциплинам */
  NoticeGroupEnum[NoticeGroupEnum["relevant_search"] = 13] = "relevant_search";
  /** Приглашение на урок */
  NoticeGroupEnum[NoticeGroupEnum["meeting"] = 14] = "meeting";
  /** Выплата  */
  NoticeGroupEnum[NoticeGroupEnum["payout"] = 15] = "payout";
  /** Новое домашнее задание */
  NoticeGroupEnum[NoticeGroupEnum["task"] = 16] = "task";
  /** Новый пост от подписчика */
  NoticeGroupEnum[NoticeGroupEnum["content"] = 17] = "content";
  /** Профиль пользователя */
  NoticeGroupEnum[NoticeGroupEnum["profile"] = 18] = "profile";
  /** Классрумы */
  NoticeGroupEnum[NoticeGroupEnum["classroom"] = 19] = "classroom";
  /** Школы */
  NoticeGroupEnum[NoticeGroupEnum["school"] = 20] = "school";
})(NoticeGroupEnum = exports.NoticeGroupEnum || (exports.NoticeGroupEnum = {}));
